import { Box, BoxProps } from "@chakra-ui/react";
import React from "react";

export type CardProps = {
  accentColor?: string;
  accentPosition?: "left" | "top" | "right" | "bottom";
  showBorder?: boolean;
  showShadow?: boolean;
  children: React.ReactNode;
  useFlex?: boolean;
} & BoxProps;
export const Card: React.FC<CardProps> = ({
  accentColor,
  accentPosition = "left",
  children,
  showBorder = false,
  showShadow = false,
  useFlex: flex = false,
  padding = 4,
  ...props
}) => {
  const borderProps: BoxProps = {
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "gray.300",
  };
  let accent: BoxProps = {};
  if (accentColor) {
    switch (accentPosition) {
      case "top": {
        accent = {
          borderTopWidth: "6px",
          borderTopStyle: "solid",
          borderTopColor: accentColor,
        };
        break;
      }
      case "right": {
        accent = {
          borderRightWidth: "6px",
          borderRightStyle: "solid",
          borderRightColor: accentColor,
        };
        break;
      }
      case "bottom": {
        accent = {
          borderBottomWidth: "6px",
          borderBottomStyle: "solid",
          borderBottomColor: accentColor,
        };
        break;
      }
      case "left":
      default: {
        accent = {
          borderLeftWidth: "6px",
          borderLeftStyle: "solid",
          borderLeftColor: accentColor,
        };
        break;
      }
    }
  }

  return (
    <Box
      {...(flex ? { display: "flex", flexDirection: "column", gap: "3" } : {})}
      borderRadius="md"
      padding={padding}
      backgroundColor="white"
      {...(showBorder ? borderProps : {})}
      {...accent}
      {...(showShadow ? { boxShadow: "md" } : {})}
      {...props}
    >
      {children}
    </Box>
  );
};
